import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { get as _get } from 'lodash';
import { Link } from 'react-router-dom';

import { constructPagePath } from 'utils/localeRouteGuide';
import { scrollToTop } from 'utils/scroll';

import localize from 'components/Localize/Localize';

import styles from './SubNav.css';
import translations from './translations';

const cx = classNames.bind(styles);

class SubNav extends React.Component {
  componentDidUpdate() {
    this.preScrollSubNav();
  }

  preScrollSubNav() {
    if (window.innerWidth >= 560 || this.props.selectedLinkIndex === 0) {
      return;
    }

    const menuEl = this.menu;

    let scrollAmount = 0;

    for (let i = 0; i < this.props.selectedLinkIndex; i++) {
      const marginLeft = parseFloat(getComputedStyle(menuEl.children[i]).getPropertyValue(`margin-left`), 10);
      const marginRight = parseFloat(getComputedStyle(menuEl.children[i]).getPropertyValue(`margin-right`), 10);
      scrollAmount += menuEl.children[i].offsetWidth - marginLeft - marginRight;
    }

    menuEl.scrollLeft = scrollAmount;
  }

  renderListItems() {
    const links = this.props.productContent.links;

    return links.map((link, i) => {
      const linkClass = cx(`menu-link`, {
        'menu-link--active': i === this.props.selectedLinkIndex,
      });

      return (
        <Link
          className={linkClass}
          key={i}
          role="button"
          to={constructPagePath(this.props.locale, link.link)}
        >
          {link.linkText}
        </Link>
      );
    }, this);
  }

  render() {
    const overviewUrl = constructPagePath(this.props.locale, this.props.productContent.links[0].link);
    const subNavInnerClass = cx(`menu-wrapper`, {
      'expose-buy-button': this.props.buyButtonIsShown,
    });

    const onClick = (e) => {
      if (window.location.pathname !== overviewUrl) {
        return;
      }

      e.preventDefault();
      scrollToTop();
    };

    return (
      <nav className={styles[`container`]}>
        <div className={styles[`inner`]}>
          <h1 className={styles[`heading`]}>
            <Link
              className={styles[`heading-link`]}
              to={overviewUrl}
            >
              {this.props.productContent.title}
            </Link>
          </h1>
          <div className={subNavInnerClass}>
            <div
              className={styles[`menu`]}
              ref={(menu) => { this.menu = menu; }}
            >
              {this.renderListItems()}
            </div>
            <Link
              className={styles[`buy-button`]}
              onClick={onClick}
              role="button"
              to={overviewUrl}
            >
              {this.props.t.buy}
            </Link>
          </div>
        </div>
      </nav>
    );
  }
}

SubNav.propTypes = {
  buyButtonIsShown: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  productContent: PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
    })).isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  selectedLinkIndex: PropTypes.number,
  t: PropTypes.shape({
    buy: PropTypes.string,
  }),
};

const mapStateToProps = (state) => ({
  buyButtonIsShown: _get(state, `UI.buyButtonIsShown`),
});

export default connect(mapStateToProps)(localize(SubNav, translations));
